import React from 'react'

const DancerPics = () => {
    return (
        <div>
            DancerPics
        </div>
    )
}

DancerPics.propTypes = {

}

export default DancerPics



// WEBPACK FOOTER //
// ./src/modules/Dashboard/components/additionalDancersInfo/DancerPics.js